export function hasConsent(type) {
  try {
    return window.localStorage.getItem('stcm.consent.' + type) === 'true'
  } catch (error) {
    return false
  }
}

export function hasAnalyticsConsent() {
  return hasConsent('analytics')
}

export function hasMarketingConsent() {
  return hasConsent('marketing')
}

export function trackFacebook(eventName, payload = {}) {
  if (!hasMarketingConsent()) return false

  if (typeof window.fbq !== 'function') {
    if (typeof window.cafodLoadGoogleTagManager === 'function') {
      window.cafodLoadGoogleTagManager()
    }

    return false
  }

  window.fbq('track', eventName, payload)
  return true
}
